(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3682,2576,2597,5901,2472,7357],{

/***/ 1842:
/***/ (function(module) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),

/***/ 45167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ protocols; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation2/index.ts + 91 modules
var Navigation2 = __webpack_require__(92609);
// EXTERNAL MODULE: ../../libs/templates/GettingStarted/index.ts + 2 modules
var GettingStarted = __webpack_require__(42576);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/SignupButton.tsx
var SignupButton = __webpack_require__(31714);
// EXTERNAL MODULE: ../../libs/templates/Forms/DemoForm/index.ts + 4 modules
var DemoForm = __webpack_require__(92472);
// EXTERNAL MODULE: ./src/views/Product/ProtocolsPage/components/Hero/assets/Hero-xs@2x.png
var Hero_xs_2x = __webpack_require__(50729);
var Hero_xs_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_xs_2x);
// EXTERNAL MODULE: ./src/views/Product/ProtocolsPage/components/Hero/assets/Hero-xs.webp
var Hero_xs = __webpack_require__(11087);
var Hero_xs_default = /*#__PURE__*/__webpack_require__.n(Hero_xs);
// EXTERNAL MODULE: ./src/views/Product/ProtocolsPage/components/Hero/assets/Hero-xs@2x.webp
var assets_Hero_xs_2x = __webpack_require__(76273);
var assets_Hero_xs_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_xs_2x);
// EXTERNAL MODULE: ./src/views/Product/ProtocolsPage/components/Hero/assets/Hero-md.png
var Hero_md = __webpack_require__(29907);
var Hero_md_default = /*#__PURE__*/__webpack_require__.n(Hero_md);
// EXTERNAL MODULE: ./src/views/Product/ProtocolsPage/components/Hero/assets/Hero-md@2x.png
var Hero_md_2x = __webpack_require__(90413);
var Hero_md_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_md_2x);
// EXTERNAL MODULE: ./src/views/Product/ProtocolsPage/components/Hero/assets/Hero-md.webp
var assets_Hero_md = __webpack_require__(6335);
var assets_Hero_md_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_md);
// EXTERNAL MODULE: ./src/views/Product/ProtocolsPage/components/Hero/assets/Hero-md@2x.webp
var assets_Hero_md_2x = __webpack_require__(89795);
var assets_Hero_md_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_md_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Product/ProtocolsPage/components/Hero/Hero.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

















var copy = {
  overline: "Protocols",
  heading: "Good data, always",
  description: "Take control of your data quality with intuitive data cleaning features and real-time validation built for enterprise scale.",
  buttonText: "Get a demo",
  linkText: "Create a free account"
};

var Hero = function Hero() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var afterContent = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* SignupButtonText */._f, {
    size: "medium",
    tag: "a",
    iconEnd: Common/* ChevronRightIcon */.XC,
    children: copy.linkText
  });

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeroComponent, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeroCopy, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            variant: "h5",
            children: copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h1",
            tag: "h1",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextDescription, {
            variant: "pExtraLarge",
            tag: "h2",
            children: copy.description
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Form */.l0, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DemoForm/* default */.Z, {
            "data-hook": "demoFormContainer",
            isProgressive: true,
            customFormIdentifier: "site-protocols-demo",
            successMessageAppearance: "twilioLight",
            after: afterContent
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Picture, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
          type: "image/webp",
          media: theme.breakpoints.up("lg", false),
          srcSet: "".concat((assets_Hero_md_default()), ", ").concat((assets_Hero_md_2x_default()), " 2x")
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
          media: theme.breakpoints.up("lg", false),
          srcSet: "".concat((Hero_md_default()), ", ").concat((Hero_md_2x_default()), " 2x")
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
          type: "image/webp",
          srcSet: "".concat((Hero_xs_default()), ", ").concat((assets_Hero_xs_2x_default()), " 2x")
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, {
          src: (Hero_xs_2x_default()),
          alt: "Illustration: Complete data collected across the entire customer journey",
          width: 1218,
          height: 584,
          loading: "lazy"
        })]
      })]
    })
  });
};

var Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "e1b31qns5"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{position:relative;top:-100px;margin-bottom:-100px;pointer-events:none;}" + ( true ? "" : 0));

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e1b31qns4"
} : 0)("position:relative;z-index:0;background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var HeroComponent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "e1b31qns3"
} : 0)("max-width:100%;", recipes_Hero/* Wrapper */.im, "{", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("md");
}, "{row-gap:20px;}}" + ( true ? "" : 0));

var HeroCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* Copy */.CK,  true ? {
  target: "e1b31qns2"
} : 0)( true ? {
  name: "1ib8u6k",
  styles: "max-width:844px"
} : 0);

var StyledCopyTextDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Description */.dk,  true ? {
  target: "e1b31qns1"
} : 0)( true ? {
  name: "1tu31wh",
  styles: "max-width:650px"
} : 0);

var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e1b31qns0"
} : 0)( true ? {
  name: "18g08sj",
  styles: "padding-bottom:0"
} : 0);

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Tabs/index.ts + 3 modules
var Tabs = __webpack_require__(74117);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CarouselCard/index.ts + 2 modules
var CarouselCard = __webpack_require__(49183);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SectionTabbed/index.ts + 2 modules
var SectionTabbed = __webpack_require__(86926);
// EXTERNAL MODULE: ./src/views/Product/ProtocolsPage/components/CreateSharedData/assets/SingleSourceOfTruth@2x.png
var SingleSourceOfTruth_2x = __webpack_require__(6859);
var SingleSourceOfTruth_2x_default = /*#__PURE__*/__webpack_require__.n(SingleSourceOfTruth_2x);
// EXTERNAL MODULE: ./src/views/Product/ProtocolsPage/components/CreateSharedData/assets/SingleSourceOfTruth.webp
var SingleSourceOfTruth = __webpack_require__(66141);
var SingleSourceOfTruth_default = /*#__PURE__*/__webpack_require__.n(SingleSourceOfTruth);
// EXTERNAL MODULE: ./src/views/Product/ProtocolsPage/components/CreateSharedData/assets/SingleSourceOfTruth@2x.webp
var assets_SingleSourceOfTruth_2x = __webpack_require__(47169);
var assets_SingleSourceOfTruth_2x_default = /*#__PURE__*/__webpack_require__.n(assets_SingleSourceOfTruth_2x);
;// CONCATENATED MODULE: ./src/views/Product/ProtocolsPage/components/CreateSharedData/SingleSourceOfTruthImage.tsx







var SingleSourceOfTruthImage = function SingleSourceOfTruthImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((SingleSourceOfTruth_default()), ", ").concat((assets_SingleSourceOfTruth_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "712",
      height: "543",
      src: (SingleSourceOfTruth_2x_default()),
      alt: "Illustration: Single source of truth",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var CreateSharedData_SingleSourceOfTruthImage = (SingleSourceOfTruthImage);
// EXTERNAL MODULE: ./src/views/Product/ProtocolsPage/components/CreateSharedData/assets/ExtensibleDocumentation@2x.png
var ExtensibleDocumentation_2x = __webpack_require__(41377);
var ExtensibleDocumentation_2x_default = /*#__PURE__*/__webpack_require__.n(ExtensibleDocumentation_2x);
// EXTERNAL MODULE: ./src/views/Product/ProtocolsPage/components/CreateSharedData/assets/ExtensibleDocumentation.webp
var ExtensibleDocumentation = __webpack_require__(7974);
var ExtensibleDocumentation_default = /*#__PURE__*/__webpack_require__.n(ExtensibleDocumentation);
// EXTERNAL MODULE: ./src/views/Product/ProtocolsPage/components/CreateSharedData/assets/ExtensibleDocumentation@2x.webp
var assets_ExtensibleDocumentation_2x = __webpack_require__(21103);
var assets_ExtensibleDocumentation_2x_default = /*#__PURE__*/__webpack_require__.n(assets_ExtensibleDocumentation_2x);
;// CONCATENATED MODULE: ./src/views/Product/ProtocolsPage/components/CreateSharedData/ExtensibleDocumentationImage.tsx







var ExtensibleDocumentationImage = function ExtensibleDocumentationImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((ExtensibleDocumentation_default()), ", ").concat((assets_ExtensibleDocumentation_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "712",
      height: "508",
      src: (ExtensibleDocumentation_2x_default()),
      alt: "Illustration: Extensible documentation",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var CreateSharedData_ExtensibleDocumentationImage = (ExtensibleDocumentationImage);
// EXTERNAL MODULE: ./src/views/Product/ProtocolsPage/components/CreateSharedData/assets/PowerfulIntegrations@2x.png
var PowerfulIntegrations_2x = __webpack_require__(17658);
var PowerfulIntegrations_2x_default = /*#__PURE__*/__webpack_require__.n(PowerfulIntegrations_2x);
// EXTERNAL MODULE: ./src/views/Product/ProtocolsPage/components/CreateSharedData/assets/PowerfulIntegrations.webp
var PowerfulIntegrations = __webpack_require__(28127);
var PowerfulIntegrations_default = /*#__PURE__*/__webpack_require__.n(PowerfulIntegrations);
// EXTERNAL MODULE: ./src/views/Product/ProtocolsPage/components/CreateSharedData/assets/PowerfulIntegrations@2x.webp
var assets_PowerfulIntegrations_2x = __webpack_require__(18349);
var assets_PowerfulIntegrations_2x_default = /*#__PURE__*/__webpack_require__.n(assets_PowerfulIntegrations_2x);
;// CONCATENATED MODULE: ./src/views/Product/ProtocolsPage/components/CreateSharedData/PowerfulIntegrationsImage.tsx








var PowerfulIntegrationsImage = function PowerfulIntegrationsImage() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      media: theme.breakpoints.up("lg", false),
      srcSet: "".concat((PowerfulIntegrations_default()), ", ").concat((assets_PowerfulIntegrations_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "712",
      height: "524",
      src: (PowerfulIntegrations_2x_default()),
      alt: "Illustration: Powerful integrations",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var CreateSharedData_PowerfulIntegrationsImage = (PowerfulIntegrationsImage);
;// CONCATENATED MODULE: ./src/views/Product/ProtocolsPage/components/CreateSharedData/CreateSharedData.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var CreateSharedData_copy = {
  heading: "Create a shared data dictionary",
  description: "Align all the teams in your company around a single data dictionary."
};
var tabs = [{
  key: "single-source-of-truth",
  title: "A Single Source of Truth",
  description: "Replace outdated spreadsheets with a living breathing Tracking Plan",
  image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CreateSharedData_SingleSourceOfTruthImage, {})
}, {
  key: "extensible-documentation",
  title: "Extensible Documentation",
  description: "Give your analysts and marketers documentation so they can confidently use your data",
  image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CreateSharedData_ExtensibleDocumentationImage, {})
}, {
  key: "powerful-integrations",
  title: "Powerful Integrations",
  description: "Reduce implementation errors with Typewriter and an extensible API",
  image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CreateSharedData_PowerfulIntegrationsImage, {})
}];

var CreateSharedData = function CreateSharedData() {
  var _useTabs = (0,Tabs/* useTabs */.YE)(tabs[0].key),
      activeTabKey = _useTabs.activeTabKey,
      getTabsProps = _useTabs.getTabsProps,
      getTabsMotionProps = _useTabs.getTabsMotionProps;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionComponent, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: CreateSharedData_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          children: CreateSharedData_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionTabbedBaseStyled, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionTabbed/* Copy */.CK, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tabs/* default */.ZP, _objectSpread(_objectSpread({}, getTabsProps()), {}, {
            mode: "vertical",
            variant: "filled",
            children: tabs.map(function (tab) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselCard/* default */.ZP, {
                value: tab.key,
                active: activeTabKey === tab.key,
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselCardContainer, {
                  alignment: "left",
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CarouselCard/* Body */.uT, {
                    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselCard/* Title */.Dx, {
                      children: tab.title
                    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselCard/* Text */.xv, {
                      children: tab.description
                    })]
                  })
                })
              }, tab.key);
            })
          }))
        }), tabs.map(function (tab) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionTabbed/* Media */.pU, _objectSpread(_objectSpread({}, getTabsMotionProps(tab.key)), {}, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionTabbed/* Picture */.t, {
              children: tab.image
            })
          }), tab.key);
        })]
      })
    })]
  });
};

var SectionComponent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e12siidr2"
} : 0)("overflow:hidden;", Section/* Wrapper */.im, "{padding-top:60px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{padding-top:120px;}}" + ( true ? "" : 0));

var SectionTabbedBaseStyled = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(SectionTabbed/* default */.ZP,  true ? {
  target: "e12siidr1"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{gap:0;}" + ( true ? "" : 0));

var CarouselCardContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CarouselCard/* Container */.W2,  true ? {
  target: "e12siidr0"
} : 0)(function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("xs");
}, "{row-gap:0;}" + ( true ? "" : 0));

/* harmony default export */ var CreateSharedData_CreateSharedData = (CreateSharedData);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ./src/views/Product/ProtocolsPage/components/DiagnoseDataQualityIssues/assets/DiagnoseDataQualityIssues@2x.png
var DiagnoseDataQualityIssues_2x = __webpack_require__(73706);
var DiagnoseDataQualityIssues_2x_default = /*#__PURE__*/__webpack_require__.n(DiagnoseDataQualityIssues_2x);
// EXTERNAL MODULE: ./src/views/Product/ProtocolsPage/components/DiagnoseDataQualityIssues/assets/DiagnoseDataQualityIssues.webp
var DiagnoseDataQualityIssues = __webpack_require__(46788);
var DiagnoseDataQualityIssues_default = /*#__PURE__*/__webpack_require__.n(DiagnoseDataQualityIssues);
// EXTERNAL MODULE: ./src/views/Product/ProtocolsPage/components/DiagnoseDataQualityIssues/assets/DiagnoseDataQualityIssues@2x.webp
var assets_DiagnoseDataQualityIssues_2x = __webpack_require__(24320);
var assets_DiagnoseDataQualityIssues_2x_default = /*#__PURE__*/__webpack_require__.n(assets_DiagnoseDataQualityIssues_2x);
;// CONCATENATED MODULE: ./src/views/Product/ProtocolsPage/components/DiagnoseDataQualityIssues/DiagnoseDataQualityIssuesImage.tsx








var DiagnoseDataQualityIssuesImage = function DiagnoseDataQualityIssuesImage() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      media: theme.breakpoints.up("lg", false),
      srcSet: "".concat((DiagnoseDataQualityIssues_default()), ", ").concat((assets_DiagnoseDataQualityIssues_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "540",
      src: (DiagnoseDataQualityIssues_2x_default()),
      alt: "Illustration: Powerful integrations",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var DiagnoseDataQualityIssues_DiagnoseDataQualityIssuesImage = (DiagnoseDataQualityIssuesImage);
;// CONCATENATED MODULE: ./src/views/Product/ProtocolsPage/components/DiagnoseDataQualityIssues/DiagnoseDataQualityIssues.tsx


function DiagnoseDataQualityIssues_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var DiagnoseDataQualityIssues_copy = {
  heading: "Diagnose data quality issues"
};
var features = [{
  heading: "Automate the QA process",
  description: "Manually testing your tracking code is time consuming and doesn\u2019t always catch every incorrect property or data type. With automatic Data Validation, you can audit your implementation in minutes."
}, {
  heading: "Have confidence making decisions with clean data",
  description: "Most companies detect issues after their team has used bad data to make decisions or trigger campaigns. Quickly take action on every invalid event with in-app reporting and daily email digests."
}];
var DiagnoseDataQualityIssues_DiagnoseDataQualityIssues = function DiagnoseDataQualityIssues() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DiagnoseDataQualityIssues_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DiagnoseDataQualityIssues_SectionComponent, {
      variant: "2Col",
      copyVariant: "narrow",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionCopy, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h2",
            children: DiagnoseDataQualityIssues_copy.heading
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrackWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
            children: features.map(function (feature) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* default */.ZP, {
                alignment: "left",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                    children: feature.heading
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Text */.xv, {
                    children: [feature.description, " "]
                  })]
                })
              }, feature.heading);
            })
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DiagnoseDataQualityIssues_DiagnoseDataQualityIssuesImage, {})
      })]
    })
  });
};

var StyledSectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e1dlqjz03"
} : 0)( true ? {
  name: "1e8a0q1",
  styles: "max-width:440px"
} : 0);

var DiagnoseDataQualityIssues_SectionComponent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1dlqjz02"
} : 0)( true ? {
  name: "1o9345a",
  styles: "overflow-x:visible;justify-content:center"
} : 0);

var ColumnTrackWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dlqjz01"
} : 0)( true ? {
  name: "1lw3ul3",
  styles: "margin-top:40px"
} : 0);

var DiagnoseDataQualityIssues_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1dlqjz00"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{padding-bottom:40px;}" + ( true ? "" : 0));

/* harmony default export */ var components_DiagnoseDataQualityIssues_DiagnoseDataQualityIssues = (DiagnoseDataQualityIssues_DiagnoseDataQualityIssues);
// EXTERNAL MODULE: ../../libs/templates/TestimonialSlider/index.ts + 11 modules
var TestimonialSlider = __webpack_require__(88302);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/CompanyMono.ts + 229 modules
var CompanyMono = __webpack_require__(71385);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/Company.ts + 237 modules
var Company = __webpack_require__(97079);
;// CONCATENATED MODULE: ./src/views/Product/ProtocolsPage/components/Testimonials/data.tsx





var testimonialData = function testimonialData() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return [{
    company: "typeform",
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TypeformMonoLogo */.wJ3, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* TypeformLogo */.HTS, {}),
    logoName: "Typeform"
  }, {
    company: "creative-market",
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CreativeMarketMonoLogo */.w1t, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* CreativeMarketLogo */.Lmn, {}),
    logoName: "CreativeMarket"
  }];
};


;// CONCATENATED MODULE: ./src/views/Product/ProtocolsPage/components/Testimonials/Testimonials.tsx


function Testimonials_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var Testimonials = function Testimonials() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSection, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TestimonialSlider["default"], {
      data: testimonialData,
      innerStyles: false
    })
  });
};

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e11kj43m0"
} : 0)( true ? {
  name: "etts4h",
  styles: "max-width:1260px;overflow-x:visible"
} : 0);

/* harmony default export */ var Testimonials_Testimonials = (Testimonials);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Accordion/index.ts + 26 modules
var Accordion = __webpack_require__(83914);
// EXTERNAL MODULE: ../../libs/utils/useActiveState/index.ts + 1 modules
var useActiveState = __webpack_require__(74864);
;// CONCATENATED MODULE: ./src/views/Product/ProtocolsPage/components/FaqSection/FaqSection.tsx







var faqData = [{
  question: "What is data cleansing?",
  answer: "Data cleansing is the process of ensuring data is complete, accurate, and reliable so that it can be used for analysis, decision-making, and reporting. Data cleansing includes correcting outdated or missing information, applying standardized naming conventions to data entries for consistency, deduplicating events, recording data transformations for transparency, and more."
}, {
  question: "What can happen when I don\u2019t use clean customer data?",
  answer: "Without properly cleaning data, organizations run the risk of basing strategies and campaigns off inaccurate or misleading information. Duplicate data entries, incomplete fields, and inconsistent naming conventions are common culprits behind \u201Cbad data,\u201D which can cost businesses millions of dollars each year in misguided insights and poor decision-making."
}];
var FaqSection_copy = {
  heading: "Frequently asked questions"
};

var FaqSection = function FaqSection() {
  var items = new Array(faqData.length).fill(false);

  var _useActiveState = (0,useActiveState/* useActiveState */.z)(items, {
    allowMultipleActive: true
  }),
      activeItems = _useActiveState.activeItems,
      toggle = _useActiveState.toggle;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
        variant: "h2",
        children: FaqSection_copy.heading
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* JsonLdFaq */.yD, {
        data: faqData.map(function (_ref) {
          var answer = _ref.answer,
              question = _ref.question;
          return {
            question: question,
            answer: answer
          };
        })
      }), activeItems.map(function (active, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* Header */.h4, {
            onClick: function onClick() {
              return toggle(index);
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* TitleWrapper */.$t, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Title */.Dx, {
                tag: "h3",
                opened: active,
                children: faqData[index].question
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Icon */.JO, {
              opened: active
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Body */.uT, {
            children: active && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* ContentWrapper */.vs, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Text */.xv, {
                children: faqData[index].answer
              })
            })
          })]
        }, "item-".concat(index));
      })]
    })
  });
};

var Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1ktykq71"
} : 0)("padding-bottom:28px;text-align:center;margin-top:0;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding-bottom:44px;}" + ( true ? "" : 0));

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1ktykq70"
} : 0)("max-width:1004px;overflow-x:unset;", Section/* Wrapper */.im, "{padding-top:0;}", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("xs");
}, "{padding-bottom:40px;}" + ( true ? "" : 0));

/* harmony default export */ var FaqSection_FaqSection = (FaqSection);
// EXTERNAL MODULE: ./src/views/Product/ProtocolsPage/assets/OgProtocols.png
var OgProtocols = __webpack_require__(56025);
var OgProtocols_default = /*#__PURE__*/__webpack_require__.n(OgProtocols);
;// CONCATENATED MODULE: ./src/views/Product/ProtocolsPage/Protocols.tsx















var ProtocolsView = function ProtocolsView() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Protocols: Customer Data Validation Tool | Twilio Segment",
      pageDescription: "Protocols offers enterprise level data cleaning and standardization to give you control over your data quality with real-time data validation.",
      pageOG: (OgProtocols_default()),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation2/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CreateSharedData_CreateSharedData, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_DiagnoseDataQualityIssues_DiagnoseDataQualityIssues, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonials_Testimonials, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FaqSection_FaqSection, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted["default"], {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e181ffu10"
} : 0)("overflow-x:hidden;background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var ProtocolsPage_Protocols = (ProtocolsView);
;// CONCATENATED MODULE: ./src/pages/product/protocols.tsx



var Protocols = function Protocols() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProtocolsPage_Protocols, {});
};

/* harmony default export */ var protocols = (Protocols);

/***/ }),

/***/ 96856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useLocation_useLocation; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/api/staticSiteBackend/client.ts + 2 modules
var client = __webpack_require__(39896);
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/location.ts



var fetchLocation = function fetchLocation(client, signal) {
  return client.get("/location/", {
    signal: signal,
    headers: [["X-Backend-Api", String("KiBZKjNMR0k4ZX1pcGZjIG9fRnh3V14m")]]
  });
};

var fetchLocationCode = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client, signal) {
    var code;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.get("/location/countryCode/", {
              signal: signal,
              headers: [["X-Backend-Api", String("KiBZKjNMR0k4ZX1pcGZjIG9fRnh3V14m")]]
            });

          case 2:
            code = _context.sent;
            return _context.abrupt("return", code.data);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchLocationCode(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();


;// CONCATENATED MODULE: ../../libs/api/utils/useLocation/useLocation.ts





/**
 * A hook that provides the country code of the user's location.
 * @returns The country code of the user's location.
 */

var useLocation = function useLocation() {
  var _useState = (0,react.useState)(""),
      code = _useState[0],
      setCode = _useState[1];

  var fetchData = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(signal) {
      var response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetchLocationCode((0,client/* createClient */.e)(), signal);

            case 3:
              response = _context.sent;
              setCode(response.toLowerCase());
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              setCode("us");

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  (0,react.useEffect)(function () {
    var controller = new AbortController();
    fetchData(controller.signal);
    return function () {
      controller.abort();
    };
  }, [fetchData]);
  return code;
};

/* harmony default export */ var useLocation_useLocation = (useLocation);
;// CONCATENATED MODULE: ../../libs/api/utils/useLocation/index.ts


/***/ }),

/***/ 805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ DemoProvider; },
/* harmony export */   "d": function() { return /* binding */ DemoContext; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52903);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var DemoContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
  completedFormData: undefined,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setCompletedFormData: function setCompletedFormData() {}
});
var DemoProvider = function DemoProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
    completedFormData: undefined,
    setCompletedFormData: function setCompletedFormData(value) {
      return setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          completedFormData: value
        });
      });
    }
  }),
      state = _useState[0],
      setState = _useState[1];

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(DemoContext.Provider, {
    value: state,
    children: children
  });
};

/***/ }),

/***/ 83914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uT": function() { return /* reexport */ Body_Body; },
  "vs": function() { return /* reexport */ ContentWrapper_ContentWrapper; },
  "h4": function() { return /* reexport */ Accordion_Header_Header; },
  "JO": function() { return /* reexport */ Icon_Icon; },
  "yD": function() { return /* reexport */ JsonLdFaq; },
  "DK": function() { return /* reexport */ Accordion_SubTitle_SubTitle; },
  "xv": function() { return /* reexport */ Accordion_Text_Text; },
  "Dx": function() { return /* reexport */ Accordion_Title_Title; },
  "$t": function() { return /* reexport */ TitleWrapper_TitleWrapper; },
  "ZP": function() { return /* reexport */ Accordion_Base_Base; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/Icon.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var VerticalLine = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u2"
} : 0)("background:", function (_ref) {
  var background = _ref.background;
  return background;
}, ";opacity:", function (_ref2) {
  var opacity = _ref2.opacity;
  return opacity;
}, ";width:2px;height:12px;transition:300ms background,300ms opacity;position:absolute;top:0;left:5px;" + ( true ? "" : 0));
var HorizontalLine = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u1"
} : 0)("background:", function (_ref3) {
  var background = _ref3.background;
  return background;
}, ";width:12px;height:2px;transition:300ms background;position:absolute;top:5px;left:0;" + ( true ? "" : 0));
var IconStyle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u0"
} : 0)( true ? {
  name: "xcbroa",
  styles: "width:12px;height:12px;position:relative"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/Icon.tsx


var _excluded = ["tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var BaseIcon = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(IconStyle, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalLine, _objectSpread({}, tokens)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalLine, _objectSpread({}, tokens))]
  }));
});
var Icon = (0,useDesignTokens/* withDesignTokens */.Y)(BaseIcon, function (_ref2) {
  var _ref2$opened = _ref2.opened,
      opened = _ref2$opened === void 0 ? false : _ref2$opened;
  return {
    opacity: opened ? 0 : 1
  };
}, {
  dark: function dark(theme, _ref3) {
    var opened = _ref3.opened;
    return {
      background: opened ? theme.palette.brand.segmentGreen[500] : theme.palette.brand.darkAcai[300]
    };
  },
  light: function light(theme, _ref4) {
    var opened = _ref4.opened;
    return {
      background: opened ? theme.palette.brand.boysenberry[500] : theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme, _ref5) {
    var opened = _ref5.opened;
    return {
      background: opened ? theme.palette.twilio.blue[60] : theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Icon_Icon = (Icon);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/Base.views.ts

var Base = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ejcpq100"
} : 0)("width:100%;border-bottom:1px solid ", function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/Base.tsx


var Base_excluded = ["children", "tokens"];

function Base_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Base_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Base_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Base_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var AccordionBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Base_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Base, Base_objectSpread(Base_objectSpread(Base_objectSpread({}, tokens), {}, {
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var Base_Base = (0,useDesignTokens/* withDesignTokens */.Y)(AccordionBase, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[300]
    };
  },
  light: function light(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[300]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      borderColor: theme.palette.twilio.gray[20]
    };
  }
});
/* harmony default export */ var Accordion_Base_Base = (Base_Base);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/index.ts

// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/Text.views.ts


function Text_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Text = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1abg28t0"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/Text.tsx


var Text_excluded = ["children", "variant", "tokens"];

function Text_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Text_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Text_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Text_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseText = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "pMedium" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Text_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, Text_objectSpread(Text_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var Text_Text = (0,useDesignTokens/* withDesignTokens */.Y)(BaseText, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_Text_Text = (Text_Text);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/index.ts

// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 1 modules
var AnimatePresence = __webpack_require__(51585);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Body/Body.tsx


var Body_excluded = ["children"];

function Body_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Body_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Body_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Body_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var Body = function Body(_ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Body_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, Body_objectSpread(Body_objectSpread({}, rest), {}, {
    initial: false,
    children: children
  }));
};

/* harmony default export */ var Body_Body = (Body);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/ContentWrapper.views.ts


function ContentWrapper_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuwow0"
} : 0)( true ? {
  name: "1sk9ltb",
  styles: "padding-bottom:32px;overflow:hidden"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/ContentWrapper.tsx


var ContentWrapper_excluded = ["children"];

function ContentWrapper_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function ContentWrapper_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ContentWrapper_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ContentWrapper_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var ContentWrapper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ContentWrapper_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion_minimal.m.div, {
    initial: "collapsed",
    animate: "open",
    exit: "collapsed",
    variants: {
      open: {
        opacity: 1,
        height: "auto"
      },
      collapsed: {
        opacity: 0,
        height: 0
      }
    },
    transition: {
      duration: 0.3,
      ease: [0.04, 0.62, 0.23, 0.98]
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, ContentWrapper_objectSpread(ContentWrapper_objectSpread({
      ref: ref
    }, rest), {}, {
      children: children
    }))
  }, "content");
});
/* harmony default export */ var ContentWrapper_ContentWrapper = (ContentWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/Title.views.ts


function Title_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "enok57o0"
} : 0)( true ? {
  name: "139xlyq",
  styles: "text-align:left;margin:16px 0;transition:300ms color"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/Title.tsx


var Title_excluded = ["children", "variant", "tokens"];

function Title_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Title_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Title_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Title_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseTitle = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "h4" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Title_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, Title_objectSpread(Title_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var Title_Title = (0,useDesignTokens/* withDesignTokens */.Y)(BaseTitle, function () {
  return {};
}, {
  light: function light(theme, _ref2) {
    var opened = _ref2.opened;
    return {
      color: opened ? theme.palette.brand.boysenberry[500] : theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme, _ref3) {
    var opened = _ref3.opened;
    return {
      color: opened ? theme.palette.brand.segmentGreen[500] : theme.palette.brand.darkAcai[300]
    };
  },
  twilioLight: function twilioLight(theme, _ref4) {
    var opened = _ref4.opened;
    return {
      color: opened ? theme.palette.twilio.blue[60] : theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_Title_Title = (Title_Title);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/SubTitle.views.ts


function SubTitle_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var SubTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "elm17wd0"
} : 0)( true ? {
  name: "jhsf3s",
  styles: "text-align:left;margin:16px 0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/SubTitle.tsx


var SubTitle_excluded = ["children", "variant", "tokens"];

function SubTitle_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function SubTitle_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? SubTitle_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SubTitle_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseSubTitle = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "pSmall" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, SubTitle_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubTitle, SubTitle_objectSpread(SubTitle_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var SubTitle_SubTitle = (0,useDesignTokens/* withDesignTokens */.Y)(BaseSubTitle, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_SubTitle_SubTitle = (SubTitle_SubTitle);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/index.ts

// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/JsonLdFaq/JsonLdFaq.tsx


var JsonLdFaq = function JsonLdFaq(_ref) {
  var data = _ref.data;
  var entities = data.map(function (_ref2) {
    var question = _ref2.question,
        answer = _ref2.answer;
    return {
      '@type': "Question",
      name: question,
      acceptedAnswer: {
        '@type': "Answer",
        text: answer
      }
    };
  });
  var json = {
    '@context': "https://schema.org",
    '@type': "FAQPage",
    mainEntity: entities
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((head_default()), {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(json)
      }
    })
  });
};
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/JsonLdFaq/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/TitleWrapper/TitleWrapper.tsx


var TitleWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e16ehyoi0"
} : 0)( true ? "" : 0);

/* harmony default export */ var TitleWrapper_TitleWrapper = (TitleWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/TitleWrapper/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/Header.views.ts



var Header = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "eqrws8a0"
} : 0)("width:100%;display:grid;gap:28px;grid-template-columns:auto auto;align-items:center;justify-content:space-between;cursor:pointer;margin:12px 0;:hover{", Title, "{color:", function (_ref) {
  var hoverTitleColor = _ref.hoverTitleColor;
  return hoverTitleColor;
}, ";}", HorizontalLine, ",", VerticalLine, "{background-color:", function (_ref2) {
  var hoverIconBackgroundColor = _ref2.hoverIconBackgroundColor;
  return hoverIconBackgroundColor;
}, ";}}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/Header.tsx


var Header_excluded = ["children", "onClick", "tokens"];

function Header_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Header_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Header_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Header_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var HeaderBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Header_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, Header_objectSpread(Header_objectSpread(Header_objectSpread({
    onClick: onClick
  }, tokens), {}, {
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var Header_Header = (0,useDesignTokens/* withDesignTokens */.Y)(HeaderBase, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      hoverTitleColor: theme.palette.brand.segmentGreen[500],
      hoverIconBackgroundColor: theme.palette.brand.segmentGreen[500]
    };
  },
  light: function light(theme) {
    return {
      hoverTitleColor: theme.palette.brand.boysenberry[500],
      hoverIconBackgroundColor: theme.palette.brand.boysenberry[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      hoverTitleColor: theme.palette.twilio.blue[60],
      hoverIconBackgroundColor: theme.palette.twilio.blue[60]
    };
  }
});
/* harmony default export */ var Accordion_Header_Header = (Header_Header);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/index.ts










Accordion_Base_Base.displayName = "AccordionBase";
Accordion_Header_Header.displayName = "Accordion.Header";
Body_Body.displayName = "Accordion.Body";
Accordion_Text_Text.displayName = "Accordion.Text";
Accordion_Title_Title.displayName = "Accordion.Title";
Accordion_SubTitle_SubTitle.displayName = "Accordion.SubTitle";
TitleWrapper_TitleWrapper.displayName = "Accordion.TitleWrapper";
ContentWrapper_ContentWrapper.displayName = "Accordion.ContentWrapper";
Icon_Icon.displayName = "Accordion.Icon";
JsonLdFaq.displayName = "Accordion.JsonLdFaq";


/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 77840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ FormSubmitMessage; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/data.tsx
var data = {
  success: {
    demo: {
      description: "Thank you for submitting your request for a demo! Answer 4 more questions to help us pinpoint exactly what your team needs to get started with Segment."
    }
  },
  error: {
    demo: {
      description: "We are really sorry. There was an error processing your submission. Try reloading your browser, and submitting again."
    }
  }
};
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10kq2lq3"
} : 0)("padding:32px;border:1px solid ", function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor;
}, ";border-radius:8px;text-align:left;" + ( true ? "" : 0));
var Header = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10kq2lq2"
} : 0)( true ? {
  name: "9qwgfz",
  styles: "display:grid;grid-auto-flow:column;grid-template-columns:max-content 1fr;align-items:center;gap:8px"
} : 0);
var StyledDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e10kq2lq1"
} : 0)( true ? {
  name: "172op4w",
  styles: "margin-top:0;margin-bottom:0"
} : 0);
var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e10kq2lq0"
} : 0)( true ? {
  name: "7ut0hf",
  styles: "margin:0;margin-bottom:16px"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.tsx


var _excluded = ["form", "status", "heading", "description", "tokens", "appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








var BaseFormSubmitMessage = function BaseFormSubmitMessage(_ref) {
  var form = _ref.form,
      status = _ref.status,
      heading = _ref.heading,
      description = _ref.description,
      tokens = _ref.tokens,
      externalAppearance = _ref.appearance,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  var localData = form && data[status][form];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: appearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread(_objectSpread({}, tokens.wrapper), rest), {}, {
      children: [heading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
          variant: "h4",
          tag: "p",
          tokens: tokens.header,
          children: heading
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDescription, {
        variant: "pMedium",
        tokens: tokens.description,
        children: description || (localData === null || localData === void 0 ? void 0 : localData.description)
      })]
    }))
  });
};

var FormSubmitMessage = (0,useDesignTokens/* withDesignTokens */.Y)(BaseFormSubmitMessage, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.brand.darkAcai[300]
      },
      description: {
        color: theme.palette.brand.darkAcai[300]
      }
    };
  },
  light: function light(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.brand.darkAcai[300]
      },
      description: {
        color: theme.palette.brand.darkAcai[500]
      }
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.twilio.gray[30]
      },
      description: {
        color: theme.palette.twilio.gray[100]
      }
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.twilio.gray[30]
      },
      description: {
        color: theme.palette.neutrals.white[100]
      }
    };
  }
});
/* harmony default export */ var FormSubmitMessage_FormSubmitMessage = ((/* unused pure expression or super */ null && (FormSubmitMessage)));

/***/ }),

/***/ 92472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ DemoForm; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/lodash/isNil.js
var isNil = __webpack_require__(1842);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/templates/FormFields/index.ts + 23 modules
var FormFields = __webpack_require__(20444);
// EXTERNAL MODULE: ../../libs/templates/Disclaimer/index.ts + 3 modules
var Disclaimer = __webpack_require__(80401);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.tsx + 2 modules
var FormSubmitMessage = __webpack_require__(77840);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/index.ts + 2 modules
var FormSubmitAction = __webpack_require__(17433);
// EXTERNAL MODULE: ../../libs/templates/TrackableForm/index.ts + 5 modules
var TrackableForm = __webpack_require__(53100);
// EXTERNAL MODULE: ../../libs/tracking/scripts/helpers.ts
var helpers = __webpack_require__(753);
// EXTERNAL MODULE: ../../libs/api/utils/useLocation/index.ts + 2 modules
var useLocation = __webpack_require__(96856);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ../../libs/utils/regexes/sharedEmail.ts
var sharedEmail = __webpack_require__(13206);
// EXTERNAL MODULE: ../../libs/utils/regexes/email.ts
var email = __webpack_require__(36219);
// EXTERNAL MODULE: ../../libs/utils/regexes/form.ts
var regexes_form = __webpack_require__(63535);
// EXTERNAL MODULE: ../../libs/utils/regexes/lastName.ts
var lastName = __webpack_require__(51895);
// EXTERNAL MODULE: ../../libs/utils/regexes/website.ts
var website = __webpack_require__(10137);
;// CONCATENATED MODULE: ../../libs/utils/regexes/personalEmail.ts
var personalEmailRegex = /@(gmail|yahoo|hotmail|me|icloud|personal)\.com$/g;
/* harmony default export */ var personalEmail = (personalEmailRegex);
;// CONCATENATED MODULE: ../../libs/utils/regexes/forbiddenEmail.ts
var customDomainList = ["@gmail.com", "@yahoo.com", "@hotmail.com", "@aol.com", "@hotmail.co.uk", "@hotmail.fr", "@msn.com", "@yahoo.fr", "@wanadoo.fr", "@orange.fr", "@comcast.net", "@yahoo.co.uk", "@yahoo.com.br", "@yahoo.co.in", "@live.com", "@rediffmail.com", "@free.fr", "@gmx.de", "@web.de", "@yandex.ru", "@ymail.com", "@libero.it", "@outlook.com", "@uol.com.br", "@bol.com.br", "@mail.ru", "@cox.net", "@hotmail.it", "@sbcglobal.net", "@sfr.fr", "@live.fr", "@verizon.net", "@live.co.uk", "@googlemail.com", "@yahoo.es", "@ig.com.br", "@live.nl", "@bigpond.com", "@terra.com.br", "@yahoo.it", "@neuf.fr", "@yahoo.de", "@alice.it", "@rocketmail.com", "@att.net", "@laposte.net", "@facebook.com", "@bellsouth.net", "@yahoo.in", "@hotmail.es", "@charter.net", "@yahoo.ca", "@yahoo.com.au", "@rambler.ru", "@hotmail.de", "@tiscali.it", "@shaw.ca", "@yahoo.co.jp", "@sky.com", "@earthlink.net", "@optonline.net", "@freenet.de", "@t-online.de", "@aliceadsl.fr", "@virgilio.it", "@home.nl", "@qq.com", "@telenet.be", "@me.com", "@yahoo.com.ar", "@tiscali.co.uk", "@yahoo.com.mx", "@voila.fr", "@gmx.net", "@mail.com", "@planet.nl", "@tin.it", "@live.it", "@ntlworld.com", "@arcor.de", "@yahoo.co.id", "@frontiernet.net", "@hetnet.nl", "@live.com.au", "@yahoo.com.sg", "@zonnet.nl", "@club-internet.fr", "@juno.com", "@optusnet.com.au", "@blueyonder.co.uk", "@bluewin.ch", "@skynet.be", "@sympatico.ca", "@windstream.net", "@mac.com", "@centurytel.net", "@chello.nl", "@live.ca", "@aim.com", "@bigpond.net.au", "@email.com", "@gmail", "@yahoo", "@hotmail", "@outlook", "@protonmail", "@gwk.com", "@free.", "@tutanota", "@gmx", "@mail2world", "@icloud", "@segment.com", "@.om", "@163.com", "@qq", "@gmai.com", "@yaoo.com", "@company.com", "@gail.com", "@abc.com", "@domain.com", "@gma.com", "@gnail.com", "@li.com", "@yah.com", "@5euros.com", "@business.com", "@emil.com", "@gaylord.info", "@gimal.com", "@gml.com", "@info.com", "@mailinator.com", "@w.com", "@yhoo.com", "@yo.com", "@0546876.com", "@10.com", "@101.gmail.com", "@11.com", "@12356gmail.com", "@123yahoo.com", "@175gmali.com", "@1servicesteamfrazier.com", "@2gmail.com", "@2ncad.com", "@365gmial.com", "@37.com", "@5024gmail.com", "@70gmail.com", "@72gmail.co.com", "@81gmail.com", "@8543g.mail.com", "@9085.gmail.com", "@9784.com", "@asdf.com", "@asdfas222334.com", "@asdsad.com", "@fuckyou.com", "@g.com", "@g.email", "@gamill.com", "@gimel.com", "@gl.com", "@gmaiil.com", "@gmaik.com", "@gmail-elif.com", "@gmail.com.pk", "@gmail.com120194", "@gmail.com4", "@gmaile.com", "@gmaill.com", "@gmaiol.com", "@gmaqil.com", "@gmaul.com", "@gmeel.come", "@gmil.comraj", "@gmsil.com", "@gmw.ere", "@gnail.con", "@haha.com", "@hahaha.com", "@il.co", "@il.com", "@test.cc", "@us.army.mil", "@ya.com", "@yaahoo.com", "@yahoo.coin", "@yho.com", "@yohoo.com", "@.aim", "@zoho", "@protonmail.com", "@mailinator", "@boutique1.com", "@bugfoo.com", "@duiter.com", "@fectode.com", "@gmial.com", "@jewelry.com", "@jims.net", "@jthoven.com", "@lolcorporate.com", "@naver.com", "@restaurant.com", "@stayclearbeauty.com", "@tem.com.my", "@thegymgroup.com", "@Marco.com"]; // Escape the dots in the domains, as they have a special meaning in regex

var escapedDomains = customDomainList.map(function (domain) {
  return domain.replace(/\./g, "\\.");
}); // Create the regex pattern using negative lookahead
// eslint-disable-next-line @typescript-eslint/naming-convention

var regexPattern = "^(?!.*(".concat(escapedDomains.join("|"), ")).*$");
var forbiddenEmailRegex = new RegExp(regexPattern, "i"); // Use the 'i' flag for case-insensitive matching

/* harmony default export */ var forbiddenEmail = (forbiddenEmailRegex);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.tsx + 2 modules
var ProgressiveProfileForm = __webpack_require__(6612);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/DemoForm.views.tsx

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc2"
} : 0)( true ? "" : 0);
var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc1"
} : 0)( true ? "" : 0);
var DisclaimerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc0"
} : 0)( true ? "" : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/DemoForm.tsx



var _excluded = ["appearance", "className", "before", "after", "isProgressive", "isLeadEnrichmentFormEnabled", "overrideConsent", "customFormIdentifier", "customTrackingType", "successMessageAppearance", "onEmailCompleted", "buttonText", "customDisclaimer", "driftCampaignId", "isDemoRequest", "successMessage"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






























var MOBILE_OFFSET = -150;
var DESKTOP_OFFSET = -350;
var FORM_ID = "demo-form"; // Set up demo form props since we define some of these props here in the template

var DemoForm = function DemoForm(_ref) {
  var appearance = _ref.appearance,
      className = _ref.className,
      before = _ref.before,
      after = _ref.after,
      _ref$isProgressive = _ref.isProgressive,
      isProgressive = _ref$isProgressive === void 0 ? false : _ref$isProgressive,
      _ref$isLeadEnrichment = _ref.isLeadEnrichmentFormEnabled,
      isLeadEnrichmentFormEnabled = _ref$isLeadEnrichment === void 0 ? true : _ref$isLeadEnrichment,
      _ref$overrideConsent = _ref.overrideConsent,
      overrideConsent = _ref$overrideConsent === void 0 ? true : _ref$overrideConsent,
      customFormIdentifier = _ref.customFormIdentifier,
      customTrackingType = _ref.customTrackingType,
      successMessageAppearance = _ref.successMessageAppearance,
      onEmailCompleted = _ref.onEmailCompleted,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? "Get a demo" : _ref$buttonText,
      customDisclaimer = _ref.customDisclaimer,
      driftCampaignId = _ref.driftCampaignId,
      _ref$isDemoRequest = _ref.isDemoRequest,
      isDemoRequest = _ref$isDemoRequest === void 0 ? false : _ref$isDemoRequest,
      customSuccessMessage = _ref.successMessage,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _usePageConfig = (0,page/* usePageConfig */.Gm)(),
      baseUrl = _usePageConfig.baseUrl;

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var formAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var countryCode = (0,useLocation/* default */.Z)(); // Initialize form here since we need the form initialized to handle progressive fields and the personal email functionality

  var _useState = (0,react.useState)(false),
      emailCompleted = _useState[0],
      setEmailCompleted = _useState[1];

  var _useState2 = (0,react.useState)(undefined),
      intPhoneErrorCode = _useState2[0],
      setIntPhoneErrorCode = _useState2[1];

  var _useState3 = (0,react.useState)(),
      submittedEmail = _useState3[0],
      setSubmittedEmail = _useState3[1];
  /* eslint-disable camelcase */


  var schema = (0,react.useMemo)(function () {
    var _z$object;

    return lib/* object */.Ry((_z$object = {
      email: lib/* string */.Z_({
        required_error: FormFields/* companyEmailMessages.required */.BN.required
      }).regex(regexes_form/* default */.Z, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      }).regex(email/* default */.Z, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      })
      /* This is equal to .email( { message: companyEmailMessages.invalid }) but with a custom regex */
      .regex(sharedEmail/* default */.C, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      }).regex(isDemoRequest ? forbiddenEmail : /.+/, {
        message: FormFields/* companyEmailMessages.forbiddenEmail */.BN.forbiddenEmail
      }),
      name: lib/* string */.Z_({
        required_error: FormFields/* fullNameMessages.required */.aZ.required
      }).regex(regexes_form/* default */.Z, {
        message: FormFields/* fullNameMessages.invalid */.aZ.invalid
      }).regex(lastName/* default */.Z, {
        message: FormFields/* fullNameMessages.invalid */.aZ.invalid
      }),
      phone: lib/* string */.Z_({
        invalid_type_error: FormFields/* phoneNumberMessages.invalid */.NJ.invalid
      }).min(1, FormFields/* phoneNumberMessages.required */.NJ.required).refine(function () {
        return intPhoneErrorCode === undefined;
      }, {
        message: (0,FormFields/* getPhoneErrorMessage */.AP)(intPhoneErrorCode)
      })
    }, (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_VALID_FIELD */.tj, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_ERRORS_FIELD */.q5, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_CALLING_COUNTRY_CODE */.iZ, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_COUNTRY_CODE */.$l, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_NUMBER */.SZ, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_NATIONAL_FORMAT */.UN, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, "company", lib/* string */.Z_({
      required_error: FormFields/* companyNameMessages.required */.qx.required
    }).regex(regexes_form/* default */.Z, {
      message: FormFields/* companyNameMessages.invalid */.qx.invalid
    })), (0,defineProperty/* default */.Z)(_z$object, "companyWebsite", lib/* string */.Z_({
      required_error: FormFields/* companyWebsiteMessages.required */.e4.required
    }).regex(regexes_form/* default */.Z, {
      message: FormFields/* companyWebsiteMessages.invalid */.e4.invalid
    }).regex(website/* default */.Z, {
      message: FormFields/* companyWebsiteMessages.invalid */.e4.invalid
    })), _z$object)).partial({
      companyWebsite: true
    });
  }, [intPhoneErrorCode]);
  /* eslint-enable camelcase */

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUnregister: true,
    resolver: (0,zod/* zodResolver */.F)(schema)
  }); // Watch for personal email

  var watchedEmail = methods === null || methods === void 0 ? void 0 : methods.watch("email", "");
  var isPersonalEmail = !isNil_default()(watchedEmail === null || watchedEmail === void 0 ? void 0 : watchedEmail.match(personalEmail)); // If this is the progressive version of the form, set up email watching
  // Otherwise just always return true

  var showProgressiveFields = isProgressive ? Boolean(watchedEmail || emailCompleted) : true; // Mobile breakpoints

  var mobileResolutionMediaQuery = theme.breakpoints.down("md", false);
  var isSmallResolution = (0,useMatchMedia/* default */.Z)(mobileResolutionMediaQuery, true);
  (0,react.useEffect)(function () {
    if (watchedEmail) {
      setEmailCompleted(true);
      if (onEmailCompleted) onEmailCompleted();
    }
  }, [watchedEmail]);
  var successMessage = customSuccessMessage || {
    heading: "Thank you, you\u2019re all set!",
    description: "We'll get back to you shortly. For now, you can create your workspace by clicking below.",
    buttonUrl: "".concat(baseUrl, "/signup/?utm_campaign=demo-request"),
    buttonText: "Create your free workspace"
  };

  var collectDriftFormData = function collectDriftFormData(formData) {
    var unTypedWindow = window;

    if (unTypedWindow.drift) {
      unTypedWindow.drift.api.collectFormData(_objectSpread(_objectSpread({}, formData), {}, {
        firstName: formData.name.split(" ")[0],
        lastName: formData.name.split(" ").slice(1).join(" ")
      }), {
        campaignId: driftCampaignId
      });
    }
  };

  (0,react.useEffect)(function () {
    if (methods.getValues("phone")) {
      methods.trigger("phone");
    }
  }, [intPhoneErrorCode]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: formAppearance,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
      id: FORM_ID,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrackableForm/* default */.Z, _objectSpread(_objectSpread({
        gap: "small",
        methods: methods,
        className: className,
        before: before,
        after: after,
        success: isLeadEnrichmentFormEnabled ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {}) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, _objectSpread({
          form: "demo",
          status: "success",
          appearance: successMessageAppearance,
          "data-hook": "demo-signup-success-message"
        }, successMessage)),
        error: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, _objectSpread({
          form: "demo",
          status: "error",
          "data-hook": "demo-form-error-message"
        }, TrackableForm/* errorMessage */.N)),
        onSubmit: function onSubmit(data) {
          setSubmittedEmail(data.email);
          (0,helpers/* createDemoLead */.Ii)(data);

          if (driftCampaignId) {
            collectDriftFormData(data);
          }

          if (isSmallResolution && showProgressiveFields) {
            (0,useScrollToAnchor/* scrollToAnchor */.d)(FORM_ID, MOBILE_OFFSET, false);
          } else {
            (0,useScrollToAnchor/* scrollToAnchor */.d)(FORM_ID, DESKTOP_OFFSET, false);
          }
        },
        onFailure: helpers/* trackValidationErrorDemoForm */.nR,
        overrideConsent: overrideConsent,
        customFormIdentifier: customFormIdentifier,
        customTrackingType: customTrackingType
      }, rest), {}, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyEmailField */.Ot, {
          onBlur: helpers/* trackValidationErrorDemoForm */.nR
        }), showProgressiveFields && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* FullNameField */.AM, {
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* PhoneNumberField */.g8, {
            countryCode: countryCode,
            onValidate: setIntPhoneErrorCode,
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyNameField */.wA, {
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          }), isPersonalEmail && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyWebsiteField */.Zf, {
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          })]
        }), customFormIdentifier && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CustomFormIdentifierField */.Fe, {
          value: customFormIdentifier
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            variant: "filled",
            size: "large",
            expanded: true,
            children: buttonText
          })
        }), showProgressiveFields && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisclaimerWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disclaimer/* default */.Z, {
            data: customDisclaimer,
            appearance: successMessageAppearance
          })
        })]
      }))
    }), isLeadEnrichmentFormEnabled && methods.formState.isSubmitSuccessful && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProgressiveProfileForm/* ProgressiveProfileForm */.u, {
      before: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitMessage/* FormSubmitMessage */.f, {
        status: "success",
        form: "demo"
      }),
      email: submittedEmail,
      successMessage: successMessage
    })]
  });
};
/* harmony default export */ var DemoForm_DemoForm = ((/* unused pure expression or super */ null && (DemoForm)));
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/index.ts


/***/ }),

/***/ 6612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ ProgressiveProfileForm; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/templates/FormFields/index.ts + 23 modules
var FormFields = __webpack_require__(20444);
// EXTERNAL MODULE: ../../libs/templates/Disclaimer/index.ts + 3 modules
var Disclaimer = __webpack_require__(80401);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/index.ts + 2 modules
var FormSubmitAction = __webpack_require__(17433);
// EXTERNAL MODULE: ../../libs/templates/FormFields/JobTitle.tsx
var JobTitle = __webpack_require__(96321);
// EXTERNAL MODULE: ../../libs/templates/FormFields/Timeline.tsx
var Timeline = __webpack_require__(12307);
// EXTERNAL MODULE: ../../libs/templates/FormFields/MonthlyTraffic.tsx
var MonthlyTraffic = __webpack_require__(75886);
// EXTERNAL MODULE: ../../libs/templates/FormFields/CompanySize.tsx
var CompanySize = __webpack_require__(20417);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/HiddenEmail.tsx


var _excluded = ["type", "name", "id", "className", "dataHook", "value"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




/**
 * Email hidden input for demo forms
 */

var HiddenEmailField = function HiddenEmailField(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "hidden" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "email" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "email" : _ref$id,
      className = _ref.className,
      dataHook = _ref.dataHook,
      value = _ref.value,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread(_objectSpread({
    "data-testid": "email",
    className: className,
    id: id,
    type: type,
    "data-hook": dataHook,
    value: value
  }, register(name, {})), rest));
};
// EXTERNAL MODULE: ../../libs/templates/TrackableForm/index.ts + 5 modules
var TrackableForm = __webpack_require__(53100);
// EXTERNAL MODULE: ../../libs/tracking/scripts/helpers.ts
var helpers = __webpack_require__(753);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ../../libs/utils/regexes/form.ts
var regexes_form = __webpack_require__(63535);
// EXTERNAL MODULE: ../../libs/contexts/demo.tsx
var demo = __webpack_require__(805);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebdrtja1"
} : 0)( true ? {
  name: "1flj9lk",
  styles: "text-align:left"
} : 0);
var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebdrtja0"
} : 0)( true ? "" : 0);
;// CONCATENATED MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.tsx



var ProgressiveProfileForm_excluded = ["appearance", "className", "before", "after", "overrideConsent", "customFormIdentifier", "successMessageAppearance", "email", "successMessage"];


function ProgressiveProfileForm_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function ProgressiveProfileForm_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ProgressiveProfileForm_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProgressiveProfileForm_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
























var BUTTON_TEXT = "Let's get started";
/* eslint-disable camelcase */

var schema = lib/* object */.Ry({
  jobTitle: lib/* string */.Z_({
    required_error: JobTitle/* jobTitleMessages.required */.cY.required
  }).regex(regexes_form/* default */.Z, {
    message: JobTitle/* jobTitleMessages.invalid */.cY.invalid
  }),
  companySize: lib/* string */.Z_({
    required_error: CompanySize/* companySizeMessages.required */.CF.required
  }),
  monthlyTraffic: lib/* string */.Z_({
    required_error: MonthlyTraffic/* monthlyTrafficMessages.required */.dn.required
  }),
  timeline: lib/* string */.Z_({
    required_error: Timeline/* timelineMessages.required */.Cb.required
  }),
  email: lib/* string */.Z_().optional()
});
/* eslint-enable camelcase */
// Set up demo form props since we define some of these props here in the template

var ProgressiveProfileForm = function ProgressiveProfileForm(_ref) {
  var appearance = _ref.appearance,
      className = _ref.className,
      before = _ref.before,
      after = _ref.after,
      _ref$overrideConsent = _ref.overrideConsent,
      overrideConsent = _ref$overrideConsent === void 0 ? true : _ref$overrideConsent,
      customFormIdentifier = _ref.customFormIdentifier,
      successMessageAppearance = _ref.successMessageAppearance,
      email = _ref.email,
      customSuccessMessage = _ref.successMessage,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ProgressiveProfileForm_excluded);

  var _usePageConfig = (0,page/* usePageConfig */.Gm)(),
      baseUrl = _usePageConfig.baseUrl;

  var formAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var scrollTo = (0,useScrollToAnchor/* default */.Z)("progressive-profile-form", -200);

  var _useContext = (0,react.useContext)(demo/* DemoContext */.d),
      setCompletedFormData = _useContext.setCompletedFormData; // Initialize form here since we need the form initialized to handle progressive fields and the personal email functionality


  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUnregister: true,
    resolver: (0,zod/* zodResolver */.F)(schema)
  });
  var successMessage = customSuccessMessage || {
    heading: "Thank you, you\u2019re all set!",
    description: "We'll get back to you shortly. For now, you can create your workspace by clicking below.",
    buttonUrl: "".concat(baseUrl, "/signup/?utm_campaign=demo-request"),
    buttonText: "Create your free workspace"
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: formAppearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
      id: "progressive-profile-form",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrackableForm/* default */.Z, ProgressiveProfileForm_objectSpread(ProgressiveProfileForm_objectSpread({
        gap: "small",
        methods: methods,
        className: className,
        before: before,
        after: after,
        success: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, ProgressiveProfileForm_objectSpread({
          form: "demo",
          status: "success",
          appearance: successMessageAppearance,
          "data-hook": "demo-signup-success-message",
          onButtonClick: function onButtonClick() {
            (0,helpers/* trackButtonClick */.kO)({
              buttonText: successMessage.buttonText,
              buttonId: "Workspace signup",
              targetUrl: successMessage.buttonUrl
            });
          }
        }, successMessage)),
        error: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, ProgressiveProfileForm_objectSpread({
          status: "error"
        }, TrackableForm/* errorMessage */.N)),
        onSubmit: /*#__PURE__*/function () {
          var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
            return regenerator_default().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    setCompletedFormData(data);
                    _context.next = 3;
                    return (0,helpers/* trackProgressiveProfileForm */.NX)(data);

                  case 3:
                    scrollTo();

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }(),
        onFailure: helpers/* trackValidationErrorProgressiveProfileForm */.An,
        overrideConsent: overrideConsent,
        customFormIdentifier: customFormIdentifier
      }, rest), {}, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JobTitle/* JobTitleField */.kL, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanySize/* CompanySizeSelectField */.BQ, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MonthlyTraffic/* MonthlyTrafficSelectField */.VW, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Timeline/* TimelineSelectField */.fz, {}), customFormIdentifier && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CustomFormIdentifierField */.Fe, {
          value: customFormIdentifier
        }), email && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HiddenEmailField, {
          value: email
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            variant: "filled",
            size: "large",
            expanded: true,
            children: BUTTON_TEXT
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disclaimer/* default */.Z, {
          appearance: successMessageAppearance
        })]
      }))
    })
  });
};
/* harmony default export */ var ProgressiveProfileForm_ProgressiveProfileForm = ((/* unused pure expression or super */ null && (ProgressiveProfileForm)));

/***/ }),

/***/ 42576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ GettingStarted; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v2"
} : 0)("overflow-y:auto;overflow-x:hidden;padding-top:80px;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v1"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:0 20px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v0"
} : 0)("display:grid;max-width:540px;width:100%;margin:0 auto;grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;max-width:327px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}













var BaseGettingStarted = function BaseGettingStarted(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Getting started is easy" : _ref$heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "Start connecting your data with Segment." : _ref$description,
      _ref$demoUtms = _ref.demoUtms,
      demoUtms = _ref$demoUtms === void 0 ? "" : _ref$demoUtms,
      tokens = _ref.tokens;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, tokens), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/".concat(demoUtms), pageConfig),
          children: "Get a demo"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
          tag: "a",
          variant: "outlined",
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Create a free account"
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  }));
};

var GettingStarted = (0,useDesignTokens/* withDesignTokens */.Y)(BaseGettingStarted, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/index.ts


/***/ }),

/***/ 51895:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var lastName = /^(?![\s\S]*\s[;,?=+\-@])[^;,?=+\-@\s][\s\S]+$/g;
/* harmony default export */ __webpack_exports__["Z"] = (lastName);

/***/ }),

/***/ 74864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ useActiveState; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useActiveState/useActiveState.tsx



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var DEFAULT_OPTIONS = {
  allowMultipleActive: false,
  minActive: 0
};
/**
 * A hook that provides a stateful array of booleans and functions to toggle, enable and disable them.
 * @param initialState The initial state of the array of booleans.
 * @param options Options to configure the hook.
 * @returns The stateful array of booleans and functions to toggle, enable and disable them.
 */

var useActiveState = function useActiveState(initialState, options) {
  var _useState = (0,react.useState)(initialState),
      activeItems = _useState[0],
      setActiveItems = _useState[1];

  var settings = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);

  var toggle = function toggle(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    if (items[index]) {
      var activeItemsLength = items.filter(function (item) {
        return item;
      }).length;

      if (activeItemsLength > settings.minActive) {
        items[index] = false;
      }
    } else {
      if (!settings.allowMultipleActive) {
        items = new Array(items.length).fill(false);
      }

      items[index] = true;
    }

    setActiveItems(items);
  };

  var enable = function enable(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    if (!settings.allowMultipleActive) {
      items = new Array(items.length).fill(false);
    }

    items[index] = true;
    setActiveItems(items);
  };

  var disable = function disable(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    var activeItemsLength = items.filter(function (item) {
      return item;
    }).length;

    if (activeItemsLength > settings.minActive) {
      items[index] = false;
      setActiveItems(items);
    }
  };

  return {
    activeItems: activeItems,
    setActiveItems: setActiveItems,
    toggle: toggle,
    enable: enable,
    disable: disable
  };
};
;// CONCATENATED MODULE: ../../libs/utils/useActiveState/index.ts


/***/ }),

/***/ 1835:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/protocols",
      function () {
        return __webpack_require__(45167);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56025:
/***/ (function(module) {

module.exports = "/_next/static/images/OgProtocols-39c12ee0246359ba830e6cb6ef0f99b0.png";

/***/ }),

/***/ 41377:
/***/ (function(module) {

module.exports = "/_next/static/images/ExtensibleDocumentation@2x-36bab03642083da263bf8c04c8134c7d.png";

/***/ }),

/***/ 17658:
/***/ (function(module) {

module.exports = "/_next/static/images/PowerfulIntegrations@2x-f0e374789e227f64176228d469cb1432.png";

/***/ }),

/***/ 6859:
/***/ (function(module) {

module.exports = "/_next/static/images/SingleSourceOfTruth@2x-4f167587274a67c01a78c30ae760c8f3.png";

/***/ }),

/***/ 73706:
/***/ (function(module) {

module.exports = "/_next/static/images/DiagnoseDataQualityIssues@2x-66f2829d59d1916023ff4427bbd7161e.png";

/***/ }),

/***/ 29907:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-md-5657190eb041fffe74f60a635a58eebf.png";

/***/ }),

/***/ 90413:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-md@2x-0ac6cbf125809934aa639e11b5729b77.png";

/***/ }),

/***/ 50729:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-xs@2x-e2137cac09b8b9b0ce815667affbed79.png";

/***/ }),

/***/ 7974:
/***/ (function(module) {

module.exports = "/_next/static/images/ExtensibleDocumentation-fddf0640c00cb86c5b5441e3bb696e51.webp";

/***/ }),

/***/ 21103:
/***/ (function(module) {

module.exports = "/_next/static/images/ExtensibleDocumentation@2x-bc692ea630912b9ae04b1211cd68af07.webp";

/***/ }),

/***/ 28127:
/***/ (function(module) {

module.exports = "/_next/static/images/PowerfulIntegrations-49f9f7533412e9d27f6b9ece8a45d249.webp";

/***/ }),

/***/ 18349:
/***/ (function(module) {

module.exports = "/_next/static/images/PowerfulIntegrations@2x-2378a704de44e4ca256a52f71bbde46d.webp";

/***/ }),

/***/ 66141:
/***/ (function(module) {

module.exports = "/_next/static/images/SingleSourceOfTruth-1b3783c0c28fd8ba0bb757d575b48829.webp";

/***/ }),

/***/ 47169:
/***/ (function(module) {

module.exports = "/_next/static/images/SingleSourceOfTruth@2x-60127f16fb00f89ce443e1d9bcc742c0.webp";

/***/ }),

/***/ 46788:
/***/ (function(module) {

module.exports = "/_next/static/images/DiagnoseDataQualityIssues-3d6b05dc4626cb17070c2afef851c66e.webp";

/***/ }),

/***/ 24320:
/***/ (function(module) {

module.exports = "/_next/static/images/DiagnoseDataQualityIssues@2x-39fb43fba9a5f7e03187a6b389436f2d.webp";

/***/ }),

/***/ 6335:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-md-1ce2a1c5aca79881ab3802bf7c476c51.webp";

/***/ }),

/***/ 89795:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-md@2x-2d8ca8b4b0bb75c9e991f2aa68c11f85.webp";

/***/ }),

/***/ 11087:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-xs-e7493c105bf277ed4cb98de0876822d2.webp";

/***/ }),

/***/ 76273:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-xs@2x-6f09f8978838a8a964da4caf092dfc2f.webp";

/***/ }),

/***/ 75536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ useAnimation; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(9340);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/animation.mjs
var animation = __webpack_require__(59413);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/setters.mjs + 3 modules
var setters = __webpack_require__(18617);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/animation-controls.mjs





/**
 * @public
 */
function animationControls() {
    /**
     * Track whether the host component has mounted.
     */
    var hasMounted = false;
    /**
     * Pending animations that are started before a component is mounted.
     * TODO: Remove this as animations should only run in effects
     */
    var pendingAnimations = [];
    /**
     * A collection of linked component animation controls.
     */
    var subscribers = new Set();
    var controls = {
        subscribe: function (visualElement) {
            subscribers.add(visualElement);
            return function () { return void subscribers.delete(visualElement); };
        },
        start: function (definition, transitionOverride) {
            /**
             * TODO: We only perform this hasMounted check because in Framer we used to
             * encourage the ability to start an animation within the render phase. This
             * isn't behaviour concurrent-safe so when we make Framer concurrent-safe
             * we can ditch this.
             */
            if (hasMounted) {
                var animations_1 = [];
                subscribers.forEach(function (visualElement) {
                    animations_1.push((0,animation/* animateVisualElement */.d5)(visualElement, definition, {
                        transitionOverride: transitionOverride,
                    }));
                });
                return Promise.all(animations_1);
            }
            else {
                return new Promise(function (resolve) {
                    pendingAnimations.push({
                        animation: [definition, transitionOverride],
                        resolve: resolve,
                    });
                });
            }
        },
        set: function (definition) {
            (0,hey_listen_es/* invariant */.k)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach(function (visualElement) {
                (0,setters/* setValues */.gg)(visualElement, definition);
            });
        },
        stop: function () {
            subscribers.forEach(function (visualElement) {
                (0,animation/* stopAnimation */.p_)(visualElement);
            });
        },
        mount: function () {
            hasMounted = true;
            pendingAnimations.forEach(function (_a) {
                var animation = _a.animation, resolve = _a.resolve;
                controls.start.apply(controls, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(animation), false)).then(resolve);
            });
            return function () {
                hasMounted = false;
                controls.stop();
            };
        },
    };
    return controls;
}



// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/use-animation.mjs




/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */
function useAnimation() {
    var controls = (0,use_constant/* useConstant */.h)(animationControls);
    (0,react.useEffect)(controls.mount, []);
    return controls;
}




/***/ }),

/***/ 28957:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ LayoutGroup; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/context/LayoutGroupContext.mjs
var LayoutGroupContext = __webpack_require__(3422);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/context/DeprecatedLayoutGroupContext.mjs


/**
 * @deprecated
 */
var DeprecatedLayoutGroupContext = (0,react.createContext)(null);



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-force-update.mjs
var use_force_update = __webpack_require__(85886);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/node/group.mjs
var notify = function (node) {
    return !node.isLayoutDirty && node.willUpdate(false);
};
function nodeGroup() {
    var nodes = new Set();
    var subscriptions = new WeakMap();
    var dirtyAll = function () { return nodes.forEach(notify); };
    return {
        add: function (node) {
            nodes.add(node);
            subscriptions.set(node, node.addEventListener("willUpdate", dirtyAll));
        },
        remove: function (node) {
            var _a;
            nodes.delete(node);
            (_a = subscriptions.get(node)) === null || _a === void 0 ? void 0 : _a();
            subscriptions.delete(node);
            dirtyAll();
        },
        dirty: dirtyAll,
    };
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/components/LayoutGroup/index.mjs








var shouldInheritGroup = function (inherit) { return inherit === true; };
var shouldInheritId = function (inherit) {
    return shouldInheritGroup(inherit === true) || inherit === "id";
};
var LayoutGroup = function (_a) {
    var _b, _c;
    var children = _a.children, id = _a.id, inheritId = _a.inheritId, _d = _a.inherit, inherit = _d === void 0 ? true : _d;
    // Maintain backwards-compatibility with inheritId until 7.0
    if (inheritId !== undefined)
        inherit = inheritId;
    var layoutGroupContext = (0,react.useContext)(LayoutGroupContext/* LayoutGroupContext */.p);
    var deprecatedLayoutGroupContext = (0,react.useContext)(DeprecatedLayoutGroupContext);
    var _e = (0,tslib_es6/* __read */.CR)((0,use_force_update/* useForceUpdate */.N)(), 2), forceRender = _e[0], key = _e[1];
    var context = (0,react.useRef)(null);
    var upstreamId = (_b = layoutGroupContext.id) !== null && _b !== void 0 ? _b : deprecatedLayoutGroupContext;
    if (context.current === null) {
        if (shouldInheritId(inherit) && upstreamId) {
            id = id ? upstreamId + "-" + id : upstreamId;
        }
        context.current = {
            id: id,
            group: shouldInheritGroup(inherit)
                ? (_c = layoutGroupContext === null || layoutGroupContext === void 0 ? void 0 : layoutGroupContext.group) !== null && _c !== void 0 ? _c : nodeGroup()
                : nodeGroup(),
        };
    }
    var memoizedContext = (0,react.useMemo)(function () { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context.current), { forceRender: forceRender })); }, [key]);
    return (react.createElement(LayoutGroupContext/* LayoutGroupContext.Provider */.p.Provider, { value: memoizedContext }, children));
};




/***/ }),

/***/ 66057:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ useElementScroll; }
/* harmony export */ });
/* harmony import */ var _utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3105);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7622);
/* harmony import */ var _events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27723);
/* harmony import */ var _utils_use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23617);
/* harmony import */ var hey_listen__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9340);






var getElementScrollOffsets = function (element) { return function () {
    return {
        xOffset: element.scrollLeft,
        yOffset: element.scrollTop,
        xMaxOffset: element.scrollWidth - element.offsetWidth,
        yMaxOffset: element.scrollHeight - element.offsetHeight,
    };
}; };
/**
 * Returns MotionValues that update when the provided element scrolls:
 *
 * - `scrollX` — Horizontal scroll distance in pixels.
 * - `scrollY` — Vertical scroll distance in pixels.
 * - `scrollXProgress` — Horizontal scroll progress between `0` and `1`.
 * - `scrollYProgress` — Vertical scroll progress between `0` and `1`.
 *
 * This element must be set to `overflow: scroll` on either or both axes to report scroll offset.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const ref = useRef()
 *   const { scrollYProgress } = useElementScroll(ref)
 *
 *   return (
 *     <div ref={ref}>
 *       <motion.div style={{ scaleX: scrollYProgress }} />
 *     </div>
 *   )
 * }
 * ```
 *
 * @public
 */
function useElementScroll(ref) {
    var values = (0,_utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_0__/* .useConstant */ .h)(_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .createScrollMotionValues */ .w);
    (0,_utils_use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicLayoutEffect */ .L)(function () {
        var element = ref.current;
        (0,hey_listen__WEBPACK_IMPORTED_MODULE_3__/* .invariant */ .k)(!!element, "ref provided to useScroll must be passed into a HTML element.");
        if (!element)
            return;
        var updateScrollValues = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .createScrollUpdater */ .S)(values, getElementScrollOffsets(element));
        var scrollListener = (0,_events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__/* .addDomEvent */ .E)(element, "scroll", updateScrollValues);
        var resizeListener = (0,_events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__/* .addDomEvent */ .E)(element, "resize", updateScrollValues);
        return function () {
            scrollListener && scrollListener();
            resizeListener && resizeListener();
        };
    }, []);
    return values;
}




/***/ }),

/***/ 7622:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ createScrollUpdater; },
/* harmony export */   "w": function() { return /* binding */ createScrollMotionValues; }
/* harmony export */ });
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40226);


function createScrollMotionValues() {
    return {
        scrollX: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollY: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollXProgress: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollYProgress: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
    };
}
function setProgress(offset, maxOffset, value) {
    value.set(!offset || !maxOffset ? 0 : offset / maxOffset);
}
function createScrollUpdater(values, getOffsets) {
    var update = function () {
        var _a = getOffsets(), xOffset = _a.xOffset, yOffset = _a.yOffset, xMaxOffset = _a.xMaxOffset, yMaxOffset = _a.yMaxOffset;
        // Set absolute positions
        values.scrollX.set(xOffset);
        values.scrollY.set(yOffset);
        // Set 0-1 progress
        setProgress(xOffset, xMaxOffset, values.scrollXProgress);
        setProgress(yOffset, yMaxOffset, values.scrollYProgress);
    };
    update();
    return update;
}




/***/ }),

/***/ 77014:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useCombineMotionValues; }
/* harmony export */ });
/* harmony import */ var _use_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21687);
/* harmony import */ var _use_on_change_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29709);
/* harmony import */ var framesync__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76432);




function useCombineMotionValues(values, combineValues) {
    /**
     * Initialise the returned motion value. This remains the same between renders.
     */
    var value = (0,_use_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useMotionValue */ .c)(combineValues());
    /**
     * Create a function that will update the template motion value with the latest values.
     * This is pre-bound so whenever a motion value updates it can schedule its
     * execution in Framesync. If it's already been scheduled it won't be fired twice
     * in a single frame.
     */
    var updateValue = function () { return value.set(combineValues()); };
    /**
     * Synchronously update the motion value with the latest values during the render.
     * This ensures that within a React render, the styles applied to the DOM are up-to-date.
     */
    updateValue();
    /**
     * Subscribe to all motion values found within the template. Whenever any of them change,
     * schedule an update.
     */
    (0,_use_on_change_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useMultiOnChange */ .f)(values, function () { return framesync__WEBPACK_IMPORTED_MODULE_0__/* ["default"].update */ .ZP.update(updateValue, false, true); });
    return value;
}




/***/ }),

/***/ 85770:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useMotionTemplate; }
/* harmony export */ });
/* harmony import */ var _use_combine_values_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77014);


/**
 * Combine multiple motion values into a new one using a string template literal.
 *
 * ```jsx
 * import {
 *   motion,
 *   useSpring,
 *   useMotionValue,
 *   useMotionTemplate
 * } from "framer-motion"
 *
 * function Component() {
 *   const shadowX = useSpring(0)
 *   const shadowY = useMotionValue(0)
 *   const shadow = useMotionTemplate`drop-shadow(${shadowX}px ${shadowY}px 20px rgba(0,0,0,0.3))`
 *
 *   return <motion.div style={{ filter: shadow }} />
 * }
 * ```
 *
 * @public
 */
function useMotionTemplate(fragments) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    /**
     * Create a function that will build a string from the latest motion values.
     */
    var numFragments = fragments.length;
    function buildValue() {
        var output = "";
        for (var i = 0; i < numFragments; i++) {
            output += fragments[i];
            var value = values[i];
            if (value)
                output += values[i].get();
        }
        return output;
    }
    return (0,_use_combine_values_mjs__WEBPACK_IMPORTED_MODULE_0__/* .useCombineMotionValues */ .N)(values, buildValue);
}




/***/ }),

/***/ 21687:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useMotionValue; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41412);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40226);
/* harmony import */ var _context_MotionConfigContext_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60976);
/* harmony import */ var _utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3105);






/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */
function useMotionValue(initial) {
    var value = (0,_utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useConstant */ .h)(function () { return (0,_index_mjs__WEBPACK_IMPORTED_MODULE_2__/* .motionValue */ .B)(initial); });
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */
    var isStatic = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_MotionConfigContext_mjs__WEBPACK_IMPORTED_MODULE_3__/* .MotionConfigContext */ ._).isStatic;
    if (isStatic) {
        var _a = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__read */ .CR)((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initial), 2), setLatest_1 = _a[1];
        (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () { return value.onChange(setLatest_1); }, []);
    }
    return value;
}




/***/ }),

/***/ 29709:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useMultiOnChange; },
/* harmony export */   "p": function() { return /* binding */ useOnChange; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _utils_is_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15815);



function useOnChange(value, callback) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if ((0,_utils_is_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isMotionValue */ .i)(value))
            return value.onChange(callback);
    }, [callback]);
}
function useMultiOnChange(values, handler) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var subscriptions = values.map(function (value) { return value.onChange(handler); });
        return function () { return subscriptions.forEach(function (unsubscribe) { return unsubscribe(); }); };
    });
}




/***/ }),

/***/ 29682:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ useTransform; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/popmotion/dist/es/utils/interpolate.mjs + 3 modules
var interpolate = __webpack_require__(1560);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/transform.mjs



var isCustomValueType = function (v) {
    return typeof v === "object" && v.mix;
};
var getMixer = function (v) { return (isCustomValueType(v) ? v.mix : undefined); };
function transform() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var useImmediate = !Array.isArray(args[0]);
    var argOffset = useImmediate ? 0 : -1;
    var inputValue = args[0 + argOffset];
    var inputRange = args[1 + argOffset];
    var outputRange = args[2 + argOffset];
    var options = args[3 + argOffset];
    var interpolator = (0,interpolate/* interpolate */.s)(inputRange, outputRange, (0,tslib_es6/* __assign */.pi)({ mixer: getMixer(outputRange[0]) }, options));
    return useImmediate ? interpolator(inputValue) : interpolator;
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/use-combine-values.mjs
var use_combine_values = __webpack_require__(77014);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/value/use-transform.mjs





function useTransform(input, inputRangeOrTransformer, outputRange, options) {
    var transformer = typeof inputRangeOrTransformer === "function"
        ? inputRangeOrTransformer
        : transform(inputRangeOrTransformer, outputRange, options);
    return Array.isArray(input)
        ? useListTransform(input, transformer)
        : useListTransform([input], function (_a) {
            var _b = (0,tslib_es6/* __read */.CR)(_a, 1), latest = _b[0];
            return transformer(latest);
        });
}
function useListTransform(values, transformer) {
    var latest = (0,use_constant/* useConstant */.h)(function () { return []; });
    return (0,use_combine_values/* useCombineMotionValues */.N)(values, function () {
        latest.length = 0;
        var numValues = values.length;
        for (var i = 0; i < numValues; i++) {
            latest[i] = values[i].get();
        }
        return transformer(latest);
    });
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,7209,6234,4136,2073,6784,8392,5735,2429,2609,948,8187,3996,7947,7960,6012,442,7079,1385,3379,814,8302,5190,8940,9774,2888,179], function() { return __webpack_exec__(1835); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);